import request from "@/common/request"
import { CampoDeEtiquetaDisponivel, ConteudoDeEtiquetasParaImprimir, EntradaDeImpressaoDeModeloDeEtiqueta, 
	EntradaDeResolucaoDeValoresDeEtiqueta, ModeloDeEtiqueta, ValoresDeCamposDeEtiqueta } from "@/models/ModeloDeEtiqueta"
import { FatiaDeImpressaoDeEtiquetas, JobDeImpressaoNoHistorico, ResultadoDeEnvioParaImpressao } from "@/models/EstacaoDeImpressao"
import { Page } from "@/models/Page"
import { AxiosRequestConfig } from "axios"

const PATH = '/modelo-etiqueta'

export const createModeloDeEtiqueta = async (modelo: ModeloDeEtiqueta): Promise<ModeloDeEtiqueta> =>
	await request.post(`${PATH}/cria`, modelo)

export const updateModeloDeEtiqueta = async (modeloEtiquetaId: string, modelo: ModeloDeEtiqueta): Promise<ModeloDeEtiqueta> =>
	await request.post(`${PATH}/atualiza/${modeloEtiquetaId}`, modelo)

export const findModeloDeEtiqueta = async (params?: any, config?: AxiosRequestConfig): Promise<Page<ModeloDeEtiqueta>> =>
	await request.get(`${PATH}/busca-modelos`, { params, ...config })

export const findModeloEtiquetaById = async (modeloEtiquetaId: string, config?: AxiosRequestConfig): Promise<ModeloDeEtiqueta> =>
	await request.get(`${PATH}/busca/${modeloEtiquetaId}`, { ...config })

export const deleteModeloDeEtiqueta = async (modeloEtiquetaId: string, config?: AxiosRequestConfig): Promise<void> =>
	await request.delete(`${PATH}/${modeloEtiquetaId}`, { ...config })

export const listarCamposDisponiveis = async (config?: AxiosRequestConfig): Promise<CampoDeEtiquetaDisponivel[]> =>
	await request.get(`${PATH}/campos-disponiveis`, { ...config })

export const resolverValoresDeCamposDeEtiqueta = async (entrada: EntradaDeResolucaoDeValoresDeEtiqueta, config?: AxiosRequestConfig): Promise<ValoresDeCamposDeEtiqueta[]> =>
	await request.post(`${PATH}/resolver-valores`, entrada, { ...config })

export const previaDeEtiquetaEmPdf = async (entrada: EntradaDeImpressaoDeModeloDeEtiqueta, config?: AxiosRequestConfig): Promise<ArrayBuffer> =>
	await request.post<any, ArrayBuffer>(`${PATH}/preview-pdf`, entrada, { responseType: 'arraybuffer', ...config })
		.catch(async (error: any) => {
			if (error?.response?.data instanceof ArrayBuffer) {
				let mensagens
				try {
					mensagens = JSON.parse(new TextDecoder('utf-8').decode(error.response.data))
					// eslint-disable-next-line no-empty
				} catch { }
				if (mensagens) {
					throw new Error(mensagens)
				}
			}
			throw error
		})

export const previaDeConteudoDeEtiqueta = async (entrada: EntradaDeImpressaoDeModeloDeEtiqueta, config?: AxiosRequestConfig): Promise<ConteudoDeEtiquetasParaImprimir> =>
	await request.post(`${PATH}/preview-conteudo`, entrada, { ...config })

// A linguagem da saída (ZPL, EPL ou TSPL) e o DPI vêm da estação, não daqui: quem imprime é que
// determina o formato.
export const gerarImpressaoParaEstacao = async (estacaoId: string, entrada: EntradaDeImpressaoDeModeloDeEtiqueta, config?: AxiosRequestConfig): Promise<FatiaDeImpressaoDeEtiquetas[]> =>
	await request.post(`${PATH}/gerar-impressao/${estacaoId}`, entrada, { ...config })

export const imprimirNaEstacao = async (estacaoId: string, entrada: EntradaDeImpressaoDeModeloDeEtiqueta, config?: AxiosRequestConfig): Promise<ResultadoDeEnvioParaImpressao> =>
	await request.post(`${PATH}/imprimir/${estacaoId}`, entrada, { ...config })

export const buscarHistoricoDeImpressao = async (lojaId: string, limite?: number, config?: AxiosRequestConfig): Promise<JobDeImpressaoNoHistorico[]> =>
	await request.get(`${PATH}/historico-de-impressao`, { params: { lojaId, limite }, ...config })

export const reimprimirJob = async (jobId: string, estacaoId?: string, config?: AxiosRequestConfig): Promise<ResultadoDeEnvioParaImpressao> =>
	await request.post(`${PATH}/reimprimir/${jobId}`, null, { params: { estacaoId }, ...config })
